var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 52,
    viewBox: "0 0 27 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97277 25.9998L26.2028 47.8172C26.3776 47.9931 26.5157 48.2018 26.6093 48.4314C26.7029 48.661 26.75 48.9068 26.748 49.1547C26.7459 49.4026 26.6947 49.6477 26.5973 49.8757C26.4999 50.1037 26.3583 50.3101 26.1806 50.483C26.0029 50.6559 25.7927 50.7918 25.5622 50.8829C25.3316 50.9741 25.0852 51.0185 24.8374 51.0138C24.5895 51.0091 24.345 50.9553 24.1181 50.8554C23.8911 50.7556 23.6862 50.6118 23.5153 50.4322L1.01527 27.3072C0.674717 26.9572 0.484177 26.4881 0.484177 25.9998C0.484177 25.5114 0.674717 25.0423 1.01527 24.6923L23.5153 1.56725C23.6862 1.38772 23.8911 1.24388 24.1181 1.14405C24.345 1.04423 24.5895 0.990399 24.8374 0.98568C25.0852 0.98096 25.3316 1.02544 25.5622 1.11656C25.7927 1.20768 26.0029 1.34361 26.1806 1.51651C26.3583 1.6894 26.4999 1.89582 26.5973 2.12381C26.6947 2.35181 26.7459 2.59685 26.748 2.84476C26.75 3.09267 26.7029 3.33854 26.6093 3.56812C26.5157 3.79769 26.3776 4.00643 26.2028 4.18225L4.97277 25.9998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.54166f00c164b4c10636439faa4f682f.svg";
export { ForwardRef as ReactComponent };